import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpParams, HttpResponse } from '@angular/common/http';

import { Observable, of } from 'rxjs';
import { tap, map, switchMap } from 'rxjs/operators';
import { Operation } from 'fast-json-patch';
import { ConfigurationService } from '../../core/services/ConfigurationService';
import { ConfigurationState } from '../../core/store/reducers';

import { DownloadReasonsReportRequest, LoadSummaryRequest, LoadSummaryResponse, DownloadSummarySearchRequest } from '../models';

@Injectable()
export class CreditReportService {
  constructor(private http: HttpClient, private configuration: ConfigurationService) {}

  getCreditReportSummary(request: LoadSummaryRequest): Observable<HttpResponse<LoadSummaryResponse>> {
    return this.configuration.config$.pipe(
      switchMap((c: ConfigurationState) => {
        return this.http.post<LoadSummaryResponse>(`${c.config.apiServer}api/credit-report/summary`, request, { observe: 'response' });
      })
    );
  }

  downloadRequestForm(id: string): Observable<boolean | HttpErrorResponse> {
    return this.configuration.config$.pipe(
      switchMap((c: ConfigurationState) => {
        return this.http.get(`${c.config.apiServer}api/credit-report/request/${id}/form`, { responseType: 'blob' }).pipe(
          tap(rsp => {
            // console.log(rsp);
          }),
          map(rsp => {
            const fileName = `Credit-Report-Request-${id}.pdf`;
            this.saveReport(rsp, fileName);
            return true;
          })
        );
      })
    );
  }

  downloadReasonsReport(criteria: DownloadReasonsReportRequest): Observable<boolean | HttpErrorResponse> {
    // check for start date is before end date
    if (criteria.startDate > criteria.endDate) {
      console.log('start date should be after end date');
      return of(false);
    }

    return this.configuration.config$.pipe(
      switchMap((c: ConfigurationState) => {
        return this.http.post(`${c.config.apiServer}api/credit-report/reasons/file`, criteria, { responseType: 'blob' }).pipe(
          map(rsp => {
            const fileName = `Credit-Report-Reasons-${criteria.startDate}-${criteria.endDate}.csv`;
            this.saveReport(rsp, fileName);
            return true;
          })
        );
      })
    );
  }

  downloadCreditCheckReportFile(criteria: DownloadSummarySearchRequest): Observable<boolean | HttpErrorResponse> {
    return this.configuration.config$.pipe(
      switchMap((c: ConfigurationState) => {
        return this.http.post(`${c.config.apiServer}api/credit-report/summary/file`, criteria, { responseType: 'blob' }).pipe(
          tap(rsp => {
            // console.log(rsp);
          }),
          map(rsp => {
            let timeStamp = '';
            if (criteria.fromDate && criteria.toDate) {
              timeStamp = `-${new Date(criteria.fromDate).toISOString()}-${new Date(criteria.toDate).toISOString()}`;
            }
            const fileName = `Credit-Report-Summary${timeStamp}.csv`;
            this.saveReport(rsp, fileName);
            return true;
          })
        );
      })
    );
  }

  private saveReport(blob: Blob, fileName: string) {
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');

    document.body.appendChild(a);
    a.setAttribute('style', 'display: none');
    a.href = url;
    a.download = fileName;
    a.click();
    setTimeout(function () {
      window.URL.revokeObjectURL(url);
    }, 1000);
    a.remove(); // remove the element
  }
}
